import { Spin } from "antd";
import { Field, Form, FormikProvider, useFormik } from "formik";
import React from "react";
import { Col, Row } from "react-bootstrap";
import CustomInput from "../../CustomControls/CustomInput";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useState } from "react";
import { post } from "../../helpers/api_helper";
import { POST_ChangePassword } from "../../helpers/url_helper";
import swal from "sweetalert";
import { errorMessage, successMessage } from "./CommonFunctions";

const UpdatePassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    OldPassword: Yup.string().required("Old Password is required field"),
    NewPassword: Yup.string()
      .required("New Password is required field")
      .matches(
        /^(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain Minimum 8 Characters, One Capital Letter and One Special Character"
      ),
    ConfirmPassword: Yup.string()
      .oneOf([Yup.ref("NewPassword"), null], "Passwords must match")
      .required("Confirm Password is a required field."),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      OldPassword: "",
      NewPassword: "",
      ConfirmPassword: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    post(POST_ChangePassword, {
      ...values,
      LoginIDEncrypted: AuthUser?.LoginIDEncrypt,
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/dashboard");
          }, 1000);
        } else {
          // swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">Update Password</h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    <Field
                      type="password"
                      label="Old Password"
                      name="OldPassword"
                      placeholder={"Enter Old Password"}
                      component={CustomInput}
                      required
                      autoFocus
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      type="password"
                      label="New Password"
                      name="NewPassword"
                      placeholder={"Enter New Password"}
                      component={CustomInput}
                      required
                    />
                  </Col>
                  <Col lg={3}>
                    <Field
                      type="password"
                      label="Confirm Password"
                      name="ConfirmPassword"
                      placeholder={"Enter Confirm Password"}
                      component={CustomInput}
                      required
                    />
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button
                  type="submit"
                  //  className="btn btn-primary"
                  className="btn btn-primary btn-sm me-2"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate("/dashboard");
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default UpdatePassword;
